import { ReactNode, HTMLAttributes } from 'react';

import {
  DefaultNotification,
  ErrorNotification,
  InfoNotification,
  SuccessNotification,
  WarningNotification,
} from './notifications';
import { NotificationDetails } from './NotificationDetails';

// Legacy API for backward compatiblity

type NotificationProps = {
  readonly info?: boolean;
  readonly success?: boolean;
  readonly warning?: boolean;
  readonly error?: boolean;
  details?: ReactNode;
  detailsLabel?: string;
};

/** @deprecated Use specific `ErrorNotification`, etc. components instead */
export const Notification = ({
  info,
  success,
  warning,
  error,
  children,
  details,
  detailsLabel,
  ...props
}: NotificationProps & HTMLAttributes<HTMLDivElement>) => {
  const kids = (
    <>
      {children}
      {details && (
        <NotificationDetails label={detailsLabel}>
          {details}
        </NotificationDetails>
      )}
    </>
  );
  if (error) {
    return <ErrorNotification {...props}>{kids}</ErrorNotification>;
  } else if (warning) {
    return <WarningNotification {...props}>{kids}</WarningNotification>;
  } else if (success) {
    return <SuccessNotification {...props}>{kids}</SuccessNotification>;
  } else if (info) {
    return <InfoNotification {...props}>{kids}</InfoNotification>;
  }
  return <DefaultNotification {...props}>{kids}</DefaultNotification>;
};
